import { render, staticRenderFns } from "./SearchRecommendationDialog.vue?vue&type=template&id=c7d84ae6&scoped=true"
import script from "./SearchRecommendationDialog.vue?vue&type=script&lang=js"
export * from "./SearchRecommendationDialog.vue?vue&type=script&lang=js"
import style0 from "./SearchRecommendationDialog.vue?vue&type=style&index=0&id=c7d84ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d84ae6",
  null
  
)

export default component.exports